module.exports = __webpack_public_path__ + "top_page/img-novelty-item@2x-a3f2f237b35c7b9fd62e116cc6456739.png";